var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClassA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_21689",
    "data-name": "Raggruppa 21689",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33088",
    "data-name": "Tracciato 33088",
    d: "M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
    fill: "#faccd5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_21501",
    "data-name": "Raggruppa 21501",
    transform: "translate(5 5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33064",
    "data-name": "Tracciato 33064",
    d: "M6.352,4.789,2.451,11.3a.921.921,0,0,0,.787,1.382h7.8a.921.921,0,0,0,.787-1.382l-3.9-6.512a.921.921,0,0,0-1.575,0Z",
    transform: "translate(-2.328 -4.346)",
    fill: "#eb3c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33065",
    "data-name": "Tracciato 33065",
    d: "M18,13.5v1.842",
    transform: "translate(-13.188 -10.689)",
    fill: "#fff",
    stroke: "#faccd5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33066",
    "data-name": "Tracciato 33066",
    d: "M18,25.5h0",
    transform: "translate(-13.188 -19.004)",
    fill: "#fff",
    stroke: "#faccd5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClassA);
export default __webpack_public_path__ + "static/media/iconClassA.97ba496d47a757edabdc24db550e047b.svg";
export { ForwardRef as ReactComponent };